const hasPositive = (indicators) => {
    return indicators?.some(i => i.readingBi?.result === 1 || i.readingCheSterilizer?.result === 3 || i.readingCheWasher?.result === 3)
}

export default hasPositive